import { FormattedMessage } from "react-intl";

export default function SubscribePasswordField({
  register,
  name,
  labelId,
  error,
  dir,
  showPassword,
  onToggle,
  className = "form-label row",
}) {
  return (
    <div className={className}>
      <div className="col-xl-4 col-lg-3">
        <label>
          <FormattedMessage id={labelId} />:
        </label>
      </div>
      <div className="col-xl-8 col-lg-9">
        <div
          className={`form-label-container ${error?.message ? "mb-3" : ""}`}
          style={{ position: "relative" }}
        >
          <input
            type={showPassword ? "text" : "password"}
            {...register(name)}
            className={`form-control ${error ? "is-invalid px-4" : ""}`}
          />
          <button
            type="button"
            className="password-toggle-btn"
            onClick={onToggle}
            style={{
              position: "absolute",
              right: dir === "rtl" ? "auto" : "20px",
              left: dir === "rtl" ? "20px" : "auto",
              top: "50%",
              transform: "translateY(-50%)",
              background: "none",
              border: "none",
              cursor: "pointer",
              fontSize: "16px",
              color: "#666",
            }}
          >
            {showPassword ? "👁️" : "👁️‍🗨️"}
          </button>
          <span>*</span>
        </div>
        {error?.message && (
          <div role="alert" className="alert alert-danger py-1">
            {error.message}
          </div>
        )}
      </div>
    </div>
  );
}
